import React from 'react'

const AdmissionProcedure = () => {
  return (
    <div>
        <div className="container-fluid p-0">
        <div className="container-fluid d-flex latest_card_box_add p-0">
          <div className="admssionleft text-left">
            <div className="title">
              <h3
                className="text-center text-uppercase"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Admission Procedure
              </h3>
              <h4 style={{color:'blueviolet',fontWeight:'bold'}}>Rules for Admission</h4>

              <p>
              Admission is purely based on merit.

Admissions must be sought through a duly filled Registration-cum-Admission Form, which should be submitted to the School Office on or before the specified date.

The child, along with their parents, will be invited for a brief meeting with the Director/Principal. This interaction will help determine whether the parents are actively involved in their child’s upbringing and whether they can collaborate with the school to ensure a holistic education.

All students seeking admission will be required to appear for an entrance test to assess their academic level and suitability for the applied grade.

As per government regulations, only students above 3 years of age shall be admitted to Nursery class, and students above 6 years shall be admitted to Class 1. For higher classes, the required age increases by one year per grade.

No candidate shall be admitted without a Transfer Certificate from the last school attended, countersigned by the appropriate authority. Under no circumstances shall a student be permitted to attend classes pending formal admission.

In case of late admission, the fee for the First Term shall be charged from the beginning of the session.
              </p>
              <h5>
                <b>Grounds for Removal from School

A student may be removed by the school authorities on any of the following grounds:</b>
              </h5>
        
              <ul type="square" style={{ color: "black", padding: "0px 20px" }}>
                <li>Behavioral issues.</li>
                <li>Failing twice in the same class.</li>
                {/* <li>
                Failing two times in the same class.
                </li> */}
              </ul>
             
              <h5>
                <b>Important Instructions</b>
              </h5>
              <ul type="square" style={{ color: "black", padding: "0px 20px" }}>
                <li>The issuance of a Registration Form does not guarantee admission.</li>
                <li>The registration fee is non-refundable.</li>
                <li>
                The Registration Form is non-transferable.
                </li>
                {/* <li>
                The following documents are to be submitted at the time of final completion of admission
                </li> */}
              </ul>
             

              

            

              <h5>
                <b>Submission of Documents:</b>
              </h5>
              <p>
              After registration, the duly filled Application Form must be submitted along with the following documents within 7 days of the registration date For the Student:
              </p>
              <ul type="square" style={{ color: "black", padding: "0px 20px" }}>
                <li>Copy of Birth Certificate, Aadhaar Card, Samagra ID, previous class marksheet, Caste Certificate (if applicable)</li>
                <li>Original Transfer Certificate.</li>
                <li>
                Latest two passport-size photos.
                </li>
                <li> Blood group.</li>
                <li>Weight details</li>
                {/* <li>Copy of Aadhar card</li>
               
                <li>Cheque Photocopy</li> */}
              </ul>


              <h5>
              For Parents: &nbsp;  </h5>
              <ul type="square" style={{ color: "black", padding: "0px 20px" }}>
<li>Copy of Aadhaar Card</li>

               </ul>
            


              <h5>
              For inquiries, email us at: &nbsp;
                <p className="linkwrap">
                <b className="bbb">Email:</b>{" "}
                <a
                  className="linkwrap mnc"
                  href="mailto: 
                    bhopalacademycoedschool@gmail.com"
                >
                 bhopalacademycoedschool@gmail.com
                </a>{" "}
              </p>
              </h5>

              {/* <h5>Get Admission procedure</h5>
              <p>
              For admissions to Buniyad (the pre primary section) the procedure is as follows:
              </p>
              <p>
              The child along with the parents will be invited to a brief meeting with the Director / Head of Buniyad where the two sides will interact. This interaction will determine whether the parents are involved with the upbringing of the child, and whether they will be able to participate with the school in the holistic education of the child.
              </p> */}
              {/* <div className="form">
                <h5><b>Admission form:</b></h5>
                <img src="./img/form.jpg" alt="" />
                <h5><b><a href="./img/form.jpg" target="_blank">Click Here For Download Admission Form</a></b></h5>
              </div> */}
              
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdmissionProcedure